import React from 'react';
import PropTypes from 'prop-types';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polygon } from 'react-google-maps';
import { googleMapUrl } from 'utils/googleMapUtils';

const Map = ({ googleMapParam, lang, stroke, paths, marker, markers, center, height }) => {
  const googleMapApiUrl = googleMapUrl(googleMapParam, lang);
  const setZoom = map => {
    if (!map) return;
    const bounds = new google.maps.LatLngBounds();
    const boundsInit = point => (
      Array.isArray(point)
        ? point.forEach(boundsInit)
        : bounds.extend(new google.maps.LatLng(point.lat, point.lng)));

    if (center || marker) {
      map.panTo(new google.maps.LatLng(center || marker.position));
    } else {
      boundsInit(paths);
      map.fitBounds(bounds);
      map.panToBounds(bounds);
    }
  };

  const googleMapProps = {
    ref: setZoom,
    defaultZoom: 2,
    defaultCenter: { lat: 0, lng: 0 },
    options: {
      mapTypeControl: true,
      overviewMapControl: true,
    },
  };

  const customOptions = {
    strokeColor: 'red',
    strokeOpacity: 0.8,
    strokeWeight: stroke ? 1 : 0,
    fillColor: 'red',
    fillOpacity: 0.35,
  };

  if (marker) {
    const MapWithMarker = withScriptjs(
      withGoogleMap(() => (
        <GoogleMap {...googleMapProps} center={marker.position} zoom={15}>
          <Marker position={new google.maps.LatLng(marker.position)} />
        </GoogleMap>
      )));

    return (
      <MapWithMarker
        googleMapURL={googleMapApiUrl}
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height }} />}
        mapElement={<div style={{ height: '100%' }} />}
      />
    );
  }

  if (markers) {
    const getIconUrl = active => (active
      ? '/statics/images/spotlight-poi-A-E.png'
      : '/statics/images/spotlight-poi-A-E-gray.png');
    const MapWithMarker = withScriptjs(
      withGoogleMap(() => (
        <GoogleMap {...googleMapProps} zoom={15}>
          {markers.map((item, index) => (
            <Marker
              key={`google-map-marker-${String(index)}`}
              icon={{
                url: getIconUrl(item.active),
                origin: new google.maps.Point(0, index * 40),
                size: new google.maps.Size(22, 40)
              }}
              zIndex={index}
              {...item}
            />
          ))}
        </GoogleMap>
      )));

    return (
      <MapWithMarker
        googleMapURL={googleMapApiUrl}
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height: '400px' }} />}
        mapElement={<div style={{ height: '100%' }} />}
      />
    );
  }
  const MapWithPolygon = withScriptjs(
    withGoogleMap(() => (
      <GoogleMap {...googleMapProps}>
        <Polygon paths={paths} options={customOptions} />
      </GoogleMap>
    )),
  );

  return (
    <MapWithPolygon
      googleMapURL={googleMapApiUrl}
      loadingElement={<div style={{ height: '100%' }} />}
      containerElement={<div style={{ height }} />}
      mapElement={<div style={{ height: '100%' }} />}
    />
  );
};

Map.propTypes = {
  googleMapParam: PropTypes.shape({
    googleMapAPIKey: PropTypes.string.isRequired,
    googleMapClientID: PropTypes.string.isRequired,
  }).isRequired,
  lang: PropTypes.string,
  stroke: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  paths: PropTypes.arrayOf(PropTypes.array),
  markers: PropTypes.arrayOf(PropTypes.shape()),
  marker: PropTypes.shape(),
  center: PropTypes.shape(),
  height: PropTypes.string,
};

Map.defaultProps = {
  lang: 'en_US',
  stroke: 0,
  paths: [],
  markers: null,
  marker: null,
  center: undefined,
  height: '400px',
};
export default Map;
